import { useFormikContext } from "formik";
import { ImageUpload } from "../../Form/ImageUpload/ImageUpload";
import { ShadowBox } from "../../UI/ShadowBox/ShadowBox";
import styles from "./UploadImageCard.module.scss";

export const UploadImageCard = ({slug, title}) => {
  const { initialValues, setFieldValue } = useFormikContext();

  return (
    <ShadowBox>
      <div className={styles.imageContainer}>
        <ImageUpload
          initialImage={initialValues.image}
          onChange={(imageFile) => {
            setFieldValue(slug, { file: imageFile });
          }}
          className={styles.imageContainer}
        />
      </div>
      <h2 className={styles.title}>{title}</h2>
    </ShadowBox>
  );
};
